import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
export function ShortcutsSheet({ open, onClose, rows, labels }) {
    const closeRef = useRef(null);
    const openerRef = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        openerRef.current = document.activeElement;
        closeRef.current?.focus();
    }, [open]);
    if (!open)
        return null;
    const close = () => {
        onClose();
        openerRef.current?.focus?.();
    };
    return (_jsx("div", { className: "shortcuts", role: "dialog", "aria-modal": "true", "aria-label": labels.title, onKeyDown: (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                close();
            }
        }, children: _jsxs("div", { className: "shortcuts__panel", children: [_jsxs("div", { className: "shortcuts__head", children: [_jsx("h2", { children: labels.title }), _jsx("button", { ref: closeRef, type: "button", onClick: close, children: labels.close })] }), _jsx("dl", { className: "shortcuts__list", children: rows.map((row) => (_jsxs("div", { className: "shortcuts__row", children: [_jsx("dt", { children: _jsx("kbd", { children: row.keys }) }), _jsx("dd", { children: row.description })] }, row.keys))) })] }) }));
}
//# sourceMappingURL=ShortcutsSheet.js.map